import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import { SectionWrapper } from 'remote-com-shared/components/SectionWrapper';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';
import SwiperCore, { Autoplay, Scrollbar, Pagination, Navigation } from 'swiper/core';
import { SwiperSlide, Swiper } from 'swiper/react';

import { DescriptionComponent, TitleComponent } from '../sharedStyles';

import { fieldHasContent } from '@/src/domains/prismic/helpers';

SwiperCore.use([Autoplay, Scrollbar, Pagination, Navigation]);

export const LogosWrapper = styled.ul`
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 0;
  list-style: none;

  & > li {
    ${fluidProp(['margin-left', 'margin-right'], '16px', '30px')};
    ${fluidProp('margin-bottom', '20px', '50px')};
  }
`;

const SliderWrapper = styled(Swiper)`
  position: relative;
  padding: 64px 0 0;
  align-items: center;

  && {
    transform: translateY(0px);
    opacity: 1;
  }

  .swiper-wrapper {
    display: flex;
    align-items: center;
  }

  .swiper-slide {
    width: 250px;
    margin: 0 10px;
  }

  .swiper-wrapper {
    -webkit-transition-timing-function: linear !important;
    -o-transition-timing-function: linear !important;
    transition-timing-function: linear !important;
    align-items: center;
  }
`;

const LogoList = styled.div`
  display: flex;
`;

const LogoEntry = styled.li`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightBG = styled.div`
  --sideGradient: linear-gradient(
    270deg,
    #dfefd3 0%,
    rgba(255, 255, 255, 0.0104167) 69.46%,
    rgba(244, 244, 244, 0) 69.47%
  );
  position: absolute;
  background-image: var(--sideGradient);
  width: 20%;
  z-index: 2;
  height: 100%;
  bottom: 0;
  right: 0;
  border: none;
`;

const LeftBG = styled(RightBG)`
  left: 0;
  transform: rotate(-180deg);
`;

export function PartnersLogoSlice({ slice }) {
  const { primary } = slice;
  const { section_id: sectionId, client_logos: clientLogos, title, description } = primary;
  const { logos } = clientLogos;

  return (
    <SectionWrapper $tone="green" $size="small" id={sectionId}>
      <LeftBG />
      <RightBG />
      {fieldHasContent(title) && (
        <TitleComponent>
          <PrismicRichText field={title} />
        </TitleComponent>
      )}
      {fieldHasContent(description) && (
        <DescriptionComponent>
          <PrismicRichText field={description} />
        </DescriptionComponent>
      )}
      {logos.length > 0 && (
        <LogosWrapper>
          <SliderWrapper
            centeredSlides
            loop
            autoplay={{
              delay: 1,
            }}
            speed={5000}
            slidesPerView="auto"
            freeMode
          >
            <LogoList>
              {logos.map(({ logo_image: logo }, index) => {
                const { dimensions: sourceDimensions } = logo;
                const isSvg = /\.svg$/i.test(logo.url);

                // Cut non-svg dimensions in half if 2x resolution
                let dimensions = sourceDimensions;
                const reference2xWidth = 200;
                if (!isSvg && dimensions.width > reference2xWidth) {
                  dimensions = {
                    width: dimensions.width / 2,
                    height: dimensions.height / 2,
                    unoptimized: true,
                  };
                }
                return (
                  <SwiperSlide key={index}>
                    <LogoEntry>
                      <Image src={logo.url} alt={logo.alt ?? ''} {...dimensions} quality="100" />
                    </LogoEntry>
                  </SwiperSlide>
                );
              })}
            </LogoList>
          </SliderWrapper>
        </LogosWrapper>
      )}
    </SectionWrapper>
  );
}
